var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("DropdownFilter", {
        attrs: {
          placeholder: "Enter keyword to search language",
          value: _vm.selectedLanguagesForDropdown,
          options: _vm.languages,
          loading: _vm.$apollo.queries.languages.loading,
          max: _vm.max,
        },
        on: {
          search: (v) => (_vm.languageSearchString = v),
          input: _vm.handleLanguageSelection,
        },
      }),
      _vm.value.length > 0
        ? _c(
            "div",
            { staticClass: "mt-3" },
            _vm._l(_vm.value, function (language) {
              return _c(
                "div",
                {
                  key: language.id,
                  staticClass:
                    "flex items-center justify-between bg-gray-50 p-3 rounded mb-2",
                },
                [
                  _c("div", { staticClass: "flex-1" }, [
                    _c("span", { staticClass: "font-medium" }, [
                      _vm._v(_vm._s(language.name)),
                    ]),
                  ]),
                  _c("div", { staticClass: "flex-1 mx-3" }, [
                    _c(
                      "select",
                      {
                        staticClass:
                          "w-full p-2 border border-gray-300 rounded",
                        domProps: { value: language.proficiency_level || 3 },
                        on: {
                          change: function ($event) {
                            return _vm.updateProficiency(
                              language.id,
                              $event.target.value
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "1" } }, [
                          _vm._v("Native"),
                        ]),
                        _c("option", { attrs: { value: "2" } }, [
                          _vm._v("Fluent/Proficient"),
                        ]),
                        _c("option", { attrs: { value: "3" } }, [
                          _vm._v("Conversational"),
                        ]),
                        _c("option", { attrs: { value: "4" } }, [
                          _vm._v("Basic"),
                        ]),
                      ]
                    ),
                  ]),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "text-red-500 hover:text-red-700 text-sm",
                        on: {
                          click: function ($event) {
                            return _vm.removeLanguage(language.id)
                          },
                        },
                      },
                      [_vm._v(" Remove ")]
                    ),
                  ]),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }